<template>
    <div
        class="attachment"
        v-if="upload"
    >
        <div
            class="attachment__icon"
            v-if="isPdf"
        >
            <i class="fas fa-file attachment__fa" />
        </div>
        <div
            class="attachment__image"
            v-if="!isPdf"
        >
            <img
                :src="upload"
                :alt="alt"
            >
        </div>
        <div class="attachment__actions">
            <a
                :href="upload"
                title="Download file"
                download
                target="_blank"
                class="attachment__download"
            ><i class="fa fa-download" /></a>
            <a
                href="#"
                v-if="!isPdf"
                @click.prevent="rotateImage"
                title="Rotate file"
                class="attachment__rotate"
            ><i class="fa fa-undo" /></a>
            <a
                href="#"
                @click.prevent="deleteImage"
                title="Delete file"
                class="attachment__delete"
            ><i class="fa fa-times" /></a>
        </div>
    </div>
</template>

<script>
import UploadService from "../../../services/UploadService";

export default {
    props: {
        upload: String,
        alt: String,
    },
    computed: {
        isPdf() {
            return this.upload && this.upload.includes('.pdf');
        }
    },
    methods: {
        rotateImage() {
            UploadService.rotateImage(this.upload).then(({data}) => {
                this.$emit('change', data.full_url);
            })
        },
        deleteImage() {
            UploadService.delete(this.upload.substring(0, this.upload.indexOf('?'))).then(({data}) => {
                this.$emit('change', '');
            })
        },
    }
}
</script>

<style scoped>
.fa-upload-photo-container {
    cursor: zoom-in;
    padding: 1rem;
    border: 1px solid lightgray;
    display: block;
    max-width: 250px;
    max-height: 250px;
    margin: 1rem 0;
}

.fa-upload-photo {
    display: block;
    max-width: 100%;
    max-height: 100%;
}

.fa-upload-pdf {
    padding: 2rem;
    border: 1px solid lightgray;
    background: white;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    font-size: 1.5rem;
    margin: 1rem 0;
    border-radius: 5px;
}
.rotate-button {
    background: white;
    border: 1px solid lightgray;
    border-radius: 3px;
    margin: 5px 0;
}
.delete-button {
    background: white;
    border: 1px solid red;
    border-radius: 3px;
    margin: 5px 0;
    color: #7a0004;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/FireAlarmUploadPreview.vue